import { Autocomplete, Box, Stack, TextField, Typography } from "@mui/material";
import { Component } from "react";
import { httpGet } from "../util/http";
//import { httpGet, httpPost } from "../util/http";

export default class ClasseSelect extends Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [
                { codClass: 'A1', nome: 'Classe A1' },
                { codClass: 'A2', nome: 'Classe A2' },
                { codClass: 'A3', nome: 'Classe A3' },
                { codClass: 'V1', nome: 'Classe V1' },
            ],
            loading: false,
        }
    }

    render() {
        return (
            <Autocomplete {...this.props.props}
                disabled={this.props.disabled}
                noOptionsText="Nenhuma classe"
                loadingText="Carregando..."
                openText="Abrir lista"
                value={this.props.value} options={this.state.items}
                size="small"
                sx={{
                    ...this.props.sx,
                }}
                isOptionEqualToValue={(option, value) => option.codClass === value.codClass}
                getOptionLabel={option => option.nome}
                onChange={(e, value) => this.props.onChange ? this.props.onChange(value) : {}}
                renderInput={(params) => <TextField
                    {...params}
                    error={this.props.error === true}
                    helperText={this.props.error === true ? "Informe a classe" : null}
                    label={'Classe' + (this.props.required ? '*' : '')} />}
            />
        );
    }
}